import React from 'react';
import PropTypes from 'prop-types';

export const FullStar = ({ empty, starColor }) => (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M55.906 10.874l-3.418 1.757c-.586.301-.97.024-.854-.635l.648-3.695-2.755-2.626c-.48-.457-.332-.904.319-.996l3.82-.543L55.365.774c.3-.593.782-.6 1.084 0l1.698 3.362 3.82.543c.656.093.8.538.32.996L59.53 8.3l.648 3.695c.114.652-.272.934-.854.635l-3.418-1.757z"
      transform="translate(-49)"
      fill={empty ? '#ebebeb' : starColor}
    />
  </svg>
);

FullStar.propTypes = {
  /*
   * To determine if star being rendered is not selected.
   */
  empty: PropTypes.bool,
};

FullStar.defaultProps = {
  empty: false,
};


export const HalfStar = ({ emptyStarColor, starColor }) => (
  <span>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="-0.5 -0.5 14 14">
      <path fill={starColor} d="M6.36.77L4.67 4.14l-3.82.54c-.65.09-.8.54-.32 1L3.28 8.3 2.63 12c-.12.66.27.94.85.63l3.42-1.76V.33a.67.67 0 0 0-.54.44z" transform="translate(-.24 -.33)" />
      <path fill={emptyStarColor} d="M11.18 12l-.65-3.7 2.76-2.63c.48-.46.34-.9-.32-1l-3.82-.53L7.45.77a.67.67 0 0 0-.54-.44v10.54l3.42 1.76c.58.3.96.02.85-.63z" transform="translate(-.24 -.33)" />
    </svg>
  </span>
);


HalfStar.propTypes = {
  /*
   * Empty half of star. Default light grey.
   */
  emptyStarColor: PropTypes.string,
};

HalfStar.defaultProps = {
  emptyStarColor: '#ebebeb',
};
